import { createFileRoute } from '@tanstack/react-router';
import { AdminDeliveryCostPage } from '@/features/admin/admin-delivery-cost-page';

export const Route = createFileRoute('/admin/delivery-cost/')({
  component: AdminDeliveryCostIndexRoute,
});

function AdminDeliveryCostIndexRoute() {
  return <AdminDeliveryCostPage />;
}
